import { Component, input, output } from '@angular/core'
import { LogoDisplayComponent } from './logo-display/logo-display.component'
import { UserWidgetComponent } from './user-widget/user-widget.component'
import { User } from 'src/app/shared/models/user'
import { FormsModule } from '@angular/forms'
import { environment } from '../../../../environments/environment'
import { UpperCasePipe } from '@angular/common'
import { appName } from '../../../shared/data-access/constant/global.constant'
import { ChantierSelectorComponent } from './chantier-selector/chantier-selector.component'
import { Chantier } from '../../../shared/models/chantier'

@Component({
  selector: 'lg-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [UserWidgetComponent, FormsModule, UpperCasePipe, LogoDisplayComponent, ChantierSelectorComponent],
})
export class HeaderComponent {
  logoUrl = input.required<string>()
  connectedUser = input<User>()
  selectedChantier = input<Chantier>()
  selectableUserChantiers = input<Chantier[]>()
  chantierSelected = output<string>()


  logout = output<void>()

  protected appName = appName
  protected readonly environment = environment

  logOut(): void {
    this.logout.emit()
  }

  onChantierSelected(selectedChantierCode: string): void {
    this.chantierSelected.emit(selectedChantierCode)
  }
}
